import { type AuthState } from '../redux/features/auth/authSlice';
import { USER_TYPES } from '../services/userRoles';

type PortalAuth = Pick<AuthState, 'isAuthenticated' | 'isSuperUser'> & {
  user?: { user_type?: string } | null;
};

export function portalHome(auth: PortalAuth): string {
  return auth.user?.user_type === USER_TYPES.customerAccountManager ? '/customer-accounts' : '/users';
}

// Both navigation and direct routes use these page states. The API enforces data access.
const PAGE_STATES_BY_ROLE: Record<string, ReadonlySet<string>> = {
  [USER_TYPES.portalUser]: new Set([
    'users', 'sku', 'batches', 'phone-configuration', 'customer-accounts',
    'key', 'api-doc', 'auditlog', 'about',
  ]),
  [USER_TYPES.customerAccountManager]: new Set(['customer-accounts', 'about']),
  [USER_TYPES.appUser]: new Set(),
};

const checkRoutePermissions = (auth: PortalAuth, route: { state: string }): boolean | 'premium' => {
  if (!auth.isAuthenticated) return false;
  // A Customer Account Manager stays within the account scope even if a
  // migrated record still carries Django's superuser flag.
  if (auth.user?.user_type === USER_TYPES.customerAccountManager) {
    return PAGE_STATES_BY_ROLE[USER_TYPES.customerAccountManager].has(route.state);
  }
  if (auth.isSuperUser) return true;
  return PAGE_STATES_BY_ROLE[auth.user?.user_type ?? '']?.has(route.state) ?? false;
};
export default checkRoutePermissions;
